import React, { useState, useEffect } from 'react';
import { Field, reduxForm } from 'redux-form';
import {
    Grid,
    Container,
    MenuItem,
    Button,
    Paper,
    Typography,
    Chip,
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Radio,
    CircularProgress,
    Tooltip,
    TextField as MuiTextField
} from '@material-ui/core';
import { connect } from 'react-redux';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import DescriptionIcon from '@material-ui/icons/Description';
import VisibilityIcon from '@material-ui/icons/Visibility';
import FileUpload from '../components/FileUpload';
import KeyboardDatePicker from '../components/KeyboardDatePicker';
import TextField from '../components/TextField';
import SelectSearch from '../components/SelectSearch';
import SelectField from '../components/SelectField';
import { currency, parseFechaEmisionUTC } from '../services/utils';
import { getCurrentUser } from '../services/auth';
import { API_RENDICIONES } from '../utils/urls';
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es');

const API_GESTOR_PAGOS = process.env.REACT_APP_API_GESTOR_PAGOS || 'https://api-gestor-pagos.cydingenieria.com';

const validate = (values = {}) => {
    const errors = {};

    // Campos requeridos base
    const baseRequiredFields = [
        'orden_compra',
        'fecha',
        'numero',
        'monto',
        'estado_pago',
        'clasificacion_factura',
        'iva',
        'descripcion'
    ];

    // Si NO es 'Documento Aprobado', el archivo es requerido
    const requiredFields = values.estado_pago !== 'Documento Aprobado'
        ? [...baseRequiredFields, 'file']
        : baseRequiredFields;

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = true;
        }
    });
    if (values.monto == "0") errors['monto'] = true;
    if (values['dias_vencimiento'] != 0 && values['dias_vencimiento'] != 15 && values['dias_vencimiento'] != 30 && values['dias_vencimiento'] != 45) errors['dias_vencimiento'] = true;
    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid email address';
    }
    return errors;
};

let FormCargarFactura = props => {
    const {
        ordenesCompra,
        handleSubmit,
        handleOnChangeFileFactura,
        fileName,
        change,
        touch,
        formCargar,
        cotizaciones,
        items,
        // Props para tabla de facturas Facele embebida
        facturasFacele,
        loadingFacturasFacele,
        searchFacturaFacele,
        handleSearchFacturaFacele,
        selectedFacturaFacele,
        handleSelectFacturaFacele,
        currentPageFacturas,
        pageSizeFacturas,
        totalCountFacturas,
        handleChangePageFacturas,
        handleChangeRowsPerPageFacturas,
        handleClose,
        handleLimpiarFacturaFacele
    } = props;
    const [clasificacionFactura, setClasificacionFactura] = useState([]);

    useEffect(() => {
        let isMounted = true; // Flag para verificar si el componente está montado

        let fetchData = async () => {
            let token = await getCurrentUser();
            let clasif = await fetch(`${API_RENDICIONES}/clasificaciones-facturas`, {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + token.token
                },
                // body: JSON.stringify(values)
            });
            let dataClasif = await clasif.json();

            // Solo actualizar el estado si el componente aún está montado
            if (isMounted) {
                setClasificacionFactura([...dataClasif.data]);
            }
        }
        fetchData();

        // Cleanup function: se ejecuta cuando el componente se desmonta
        return () => {
            isMounted = false;
        };
    }, []);

    // Limpiar archivo cuando estado_pago cambia y NO es 'Documento Aprobado'
    useEffect(() => {
        const estadoPago = formCargar?.values?.estado_pago;

        // Si el estado cambia y NO es 'Documento Aprobado', limpiar el archivo
        if (estadoPago && estadoPago !== 'Documento Aprobado' && fileName) {
            handleOnChangeFileFactura({ target: { files: [] } });
            change('file', null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formCargar?.values?.estado_pago]);

    // Limpiar campos autocompletados y selección de factura cuando se cambia estado_pago
    useEffect(() => {
        const estadoPago = formCargar?.values?.estado_pago;

        // Si el estado NO es 'Documento Aprobado', limpiar campos y selección
        if (estadoPago && estadoPago !== 'Documento Aprobado') {
            if (selectedFacturaFacele && change && handleLimpiarFacturaFacele) {
                // Limpiar los campos que se llenaron automáticamente
                change('numero', '');
                change('monto', '0');
                change('iva', '0');
                change('fecha', null);
                // Limpiar el estado de factura seleccionada
                handleLimpiarFacturaFacele();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formCargar?.values?.estado_pago]);

    // La tabla de facturas se muestra automáticamente cuando estado_pago es 'Documento Aprobado' y hay orden de compra

    const handleChangeOC = async (name, newValue) => {
        change(name, newValue);
        let newDescr = 'Compra de ';
        if (ordenesCompra.find(x => x.id === newValue)) {
            let clasesNom = [];
            let cotizacion = cotizaciones.find(x => x.ordenCompra?.id === newValue);
            cotizacion.item_cotizacion.forEach(x => {
                let itemSol = items.find(y => y.id === x.item_recurso_id);
                if (clasesNom.indexOf(itemSol.claseRef.nombre) == -1)
                    clasesNom.push(itemSol.claseRef.nombre);
            });
            newDescr += clasesNom.join(', ');
        }
        change('descripcion', newDescr);
    }

    return (
        <Container>
            <form noValidate onSubmit={handleSubmit}>
                <Grid container>
                    <Grid item xs={12} lg={6}>
                        <Grid container justify="center" alignItems="center">
                            <Field
                                required
                                style={{ width: '95%' }}
                                type="text"
                                change={handleChangeOC}
                                touch={touch}
                                name="orden_compra"
                                label="Órden de Compra"
                                options={ordenesCompra}
                                component={SelectSearch}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Grid container justify="center" alignItems="center">
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} lg={6}>
                        <Grid container justify="center" alignItems="center">
                            <Field
                                required
                                style={{ width: '95%' }}
                                name="fecha"
                                label="Fecha Factura"
                                change={change}
                                component={KeyboardDatePicker}
                                disabled={formCargar?.values?.estado_pago === 'Documento Aprobado' && formCargar?.values?.orden_compra}
                                InputProps={{
                                    style: (formCargar?.values?.estado_pago === 'Documento Aprobado' && formCargar?.values?.orden_compra) ? { backgroundColor: '#f5f5f5', color: '#757575' } : {}
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Grid container justify="center" alignItems="center">
                            <Field
                                required
                                style={{ width: '95%' }}
                                name="estado_pago"
                                label="Estado del pago"
                                component={SelectField}>
                                {[
                                    <MenuItem key="" value="">
                                        Seleccionar
                                    </MenuItem>
                                ].concat(
                                    [
                                        { nombre: 'Orden de pago directo a proveedor', valor: 'Documento Aprobado' }, //actualizado de 'Procesando Pago' a 'Documento Aprobado' el 06-11-2025
                                        { nombre: 'Pagado (Rendir en Gestor de Pagos)', valor: 'Pagado' }
                                    ].map((x, id) => (
                                        <MenuItem key={id} value={x.valor}>
                                            {x.nombre}
                                        </MenuItem>
                                    ))
                                )}
                            </Field>
                        </Grid>
                    </Grid>
                </Grid>
                {formCargar?.values?.estado_pago == 'Documento Aprobado' && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    required
                                    style={{ width: '95%' }}
                                    name="clasificacion_factura"
                                    label="Clasificación Factura"
                                    type="text"
                                    change={change}
                                    touch={touch}
                                    options={clasificacionFactura}
                                    component={SelectSearch}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    required
                                    style={{ width: '95%' }}
                                    name="dias_vencimiento"
                                    label="Plazo Pago"
                                    component={SelectField}>
                                    {[
                                        <MenuItem key="" value="">
                                            Seleccionar
                                        </MenuItem>
                                    ].concat(
                                        [
                                            { nombre: 'Contado', valor: 0 },
                                            { nombre: 'A 15 días', valor: 15 },
                                            { nombre: 'A 30 días', valor: 30 },
                                            { nombre: 'A 45 días', valor: 45 }
                                        ].map((x, id) => (
                                            <MenuItem key={id} value={x.valor}>
                                                {x.nombre}
                                            </MenuItem>
                                        ))
                                    )}
                                </Field>
                            </Grid>
                        </Grid>
                    </Grid>
                )}



                <Grid container>
                    <Grid item xs={12} lg={6}>
                        <Grid container justify="center" alignItems="center">
                            <Field
                                required
                                style={{ width: '95%' }}
                                type="number"
                                name="numero"
                                label="Número Factura"
                                component={TextField}
                                disabled={formCargar?.values?.estado_pago === 'Documento Aprobado' && formCargar?.values?.orden_compra}
                                InputProps={{
                                    style: (formCargar?.values?.estado_pago === 'Documento Aprobado' && formCargar?.values?.orden_compra) ? { backgroundColor: '#f5f5f5', color: '#757575' } : {}
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <Grid container justify="center" alignItems="center">
                            <Field
                                required
                                style={{ width: '90%' }}
                                format={currency}
                                name="monto"
                                label="Total Factura"
                                component={TextField}
                                disabled={formCargar?.values?.estado_pago === 'Documento Aprobado' && formCargar?.values?.orden_compra}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                    style: (formCargar?.values?.estado_pago === 'Documento Aprobado' && formCargar?.values?.orden_compra) ? { backgroundColor: '#f5f5f5', color: '#757575' } : {}
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <Grid container justify="center" alignItems="center">
                            <Field
                                required
                                style={{ width: '90%' }}
                                format={currency}
                                name="iva"
                                label="IVA Factura"
                                component={TextField}
                                disabled={formCargar?.values?.estado_pago === 'Documento Aprobado' && formCargar?.values?.orden_compra}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                    style: (formCargar?.values?.estado_pago === 'Documento Aprobado' && formCargar?.values?.orden_compra) ? { backgroundColor: '#f5f5f5', color: '#757575' } : {}
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>


                {/* SECCION TABLA DE FACTURAS */}
                {/* Tabla de Facturas Disponibles - Mostrar cuando estado_pago es 'Documento Aprobado' */}
                {formCargar?.values?.estado_pago === 'Documento Aprobado' && formCargar?.values?.orden_compra && (
                    <>
                        {/* Título */}
                        <Grid container spacing={3} style={{ marginTop: 20, marginBottom: 10 }} alignItems="center">
                            <Grid item xs={12}>
                                <Typography variant="h6">Facturas Disponibles</Typography>
                            </Grid>
                        </Grid>
                        {/* Contenedor con texto y buscador */}
                        <Box
                            style={{
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0',
                                overflow: 'hidden'
                            }}>
                            <Grid container style={{ marginBottom: 0 }}>
                                <Grid item xs={12}>
                                    <Box
                                        style={{
                                            padding: '12px 16px',
                                            backgroundColor: '#fff',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            minHeight: '56px'
                                        }}>
                                        <Typography variant="body2" style={{ fontSize: '14px', color: '#666', fontWeight: 400 }}>
                                            Seleccione una fila para autocompletar
                                        </Typography>
                                        <MuiTextField
                                            style={{ width: 300 }}
                                            placeholder="Buscar facturas..."
                                            variant="outlined"
                                            size="small"
                                            value={searchFacturaFacele || ''}
                                            onChange={(e) => handleSearchFacturaFacele(e.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon color="action" />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                            {loadingFacturasFacele ? (
                                <Grid container justify="center" alignItems="center" style={{ padding: 40 }}>
                                    <Grid item>
                                        <CircularProgress size={40} />
                                    </Grid>
                                    <Grid item xs={12} style={{ textAlign: 'center', marginTop: 16 }}>
                                        <Typography variant="body1">Cargando facturas...</Typography>
                                    </Grid>
                                </Grid>
                            ) : facturasFacele && facturasFacele.length > 0 ? (
                                <Grid container spacing={0} style={{ marginBottom: 0 }}>
                                    <Grid item xs={12}>
                                        <TableContainer component={Paper} style={{ flex: 1, position: 'relative' }}>
                                            <Table stickyHeader size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell
                                                            padding="checkbox"
                                                            style={{
                                                                backgroundColor: '#fff',
                                                                position: 'sticky',
                                                                left: 0,
                                                                zIndex: 3
                                                            }}>
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                backgroundColor: '#fff',
                                                                minWidth: 100
                                                            }}>
                                                            <strong>Folio</strong>
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                backgroundColor: '#fff',
                                                                minWidth: 300
                                                            }}>
                                                            <strong>Sociedad</strong>
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                backgroundColor: '#fff',
                                                                minWidth: 120
                                                            }}>
                                                            <strong>Fecha Factura</strong>
                                                        </TableCell>
                                                        <TableCell
                                                            align="right"
                                                            style={{
                                                                backgroundColor: '#fff',
                                                                minWidth: 120
                                                            }}>
                                                            <strong>Monto Total</strong>
                                                        </TableCell>
                                                        <TableCell
                                                            align="right"
                                                            style={{
                                                                backgroundColor: '#fff',
                                                                minWidth: 120
                                                            }}>
                                                            <strong>IVA</strong>
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            style={{
                                                                backgroundColor: '#fff',
                                                                minWidth: 150
                                                            }}>
                                                            <strong>Notas de Crédito</strong>
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            style={{
                                                                backgroundColor: '#fff',
                                                                minWidth: 120
                                                            }}>
                                                            <strong>Orden de compra</strong>
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            style={{
                                                                backgroundColor: '#fff',
                                                                position: 'sticky',
                                                                right: 0,
                                                                zIndex: 3,
                                                                minWidth: 100
                                                            }}>
                                                            <strong>Acciones</strong>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {facturasFacele.map((factura) => (
                                                        <TableRow
                                                            key={factura._id}
                                                            hover
                                                            style={{ cursor: 'pointer' }}
                                                            selected={selectedFacturaFacele?._id === factura._id}
                                                            onClick={() => handleSelectFacturaFacele(factura)}>
                                                            <TableCell
                                                                padding="checkbox"
                                                                style={{
                                                                    position: 'sticky',
                                                                    left: 0,
                                                                    backgroundColor: selectedFacturaFacele?._id === factura._id ? '#e3f2fd' : '#fff',
                                                                    zIndex: 2
                                                                }}>
                                                                <Radio
                                                                    checked={selectedFacturaFacele?._id === factura._id}
                                                                    color="primary"
                                                                />
                                                            </TableCell>
                                                            <TableCell><strong>{factura.folio_dte}</strong></TableCell>
                                                            <TableCell>{factura.razon_social_receptor || '—'}</TableCell>
                                                            <TableCell>{parseFechaEmisionUTC(factura.fecha_emision)?.format('DD/MM/YYYY') || '—'}</TableCell>
                                                            <TableCell align="right">${factura.monto_total?.toLocaleString('es-CL')}</TableCell>
                                                            <TableCell align="right">${factura.monto_iva?.toLocaleString('es-CL')}</TableCell>
                                                            <TableCell align="center">
                                                                {factura.notas && factura.notas.length > 0 ? (
                                                                    <Box style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                                                        {factura.notas.map((nota, index) => (
                                                                            <Tooltip key={index} title={`Ver Nota de Crédito N° ${nota.folio}`}>
                                                                                <Chip
                                                                                    size="small"
                                                                                    icon={<DescriptionIcon style={{ fontSize: 16 }} />}
                                                                                    label={`N° ${nota.folio}`}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        if (nota.url_pdf) {
                                                                                            window.open(nota.url_pdf, '_blank');
                                                                                        }
                                                                                    }}
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        backgroundColor: '#e8f5e9',
                                                                                        color: '#2e7d32'
                                                                                    }}
                                                                                />
                                                                            </Tooltip>
                                                                        ))}
                                                                    </Box>
                                                                ) : (
                                                                    <Typography variant="body2" style={{ color: '#999', fontSize: '12px' }}>
                                                                        —
                                                                    </Typography>
                                                                )}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {factura.codigo_oc ? (
                                                                    <Typography variant="body2" style={{ fontSize: '14px' }}>
                                                                        {factura.codigo_oc}
                                                                    </Typography>
                                                                ) : (
                                                                    <Typography variant="body2" style={{ color: '#999', fontSize: '12px' }}>
                                                                        —
                                                                    </Typography>
                                                                )}
                                                            </TableCell>
                                                            <TableCell
                                                                align="center"
                                                                style={{
                                                                    position: 'sticky',
                                                                    right: 0,
                                                                    backgroundColor: selectedFacturaFacele?._id === factura._id ? '#e3f2fd' : '#fff',
                                                                    zIndex: 2
                                                                }}>
                                                                <Tooltip title="Ver Factura PDF">
                                                                    <IconButton
                                                                        size="small"
                                                                        style={{ color: "#4A4B4D" }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            if (factura.url_pdf) {
                                                                                window.open(factura.url_pdf, '_blank');
                                                                            }
                                                                        }}>
                                                                        <VisibilityIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                component="div"
                                                count={totalCountFacturas || 0}
                                                page={currentPageFacturas || 0}
                                                onChangePage={handleChangePageFacturas}
                                                rowsPerPage={pageSizeFacturas || 5}
                                                onChangeRowsPerPage={handleChangeRowsPerPageFacturas}
                                                rowsPerPageOptions={[5, 10, 20, 50]}
                                                labelRowsPerPage="Filas por página:"
                                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                                            />
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            ) : (
                                <Grid container justify="center" style={{ padding: 20 }}>
                                    <Typography variant="body2" color="textSecondary">
                                        No se encontraron facturas disponibles para este proveedor.
                                    </Typography>
                                </Grid>
                            )}
                        </Box>
                    </>
                )}
                {/* FIN SECCION TABLA FACTURAS */}

                {formCargar?.values?.estado_pago == 'Documento Aprobado' && (
                    <Grid container spacing={3} style={{marginTop: '16px'}}>
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    required
                                    multiline
                                    type="text"
                                    name="descripcion"
                                    rows="4"
                                    characterLimit={200}
                                    inputProps={{
                                        maxLength: '200'
                                    }}
                                    style={{ width: '95%' }}
                                    label="Descripción"
                                    component={TextField}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    multiline
                                    type="text"
                                    name="comentario"
                                    rows="4"
                                    characterLimit={200}
                                    inputProps={{
                                        maxLength: '200'
                                    }}
                                    style={{ width: '95%' }}
                                    label="Comentario (opcional)"
                                    component={TextField}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                )}
                {/* Solo mostrar carga de archivo si NO es 'Documento Aprobado' */}
                {formCargar?.values?.estado_pago !== 'Documento Aprobado' && (
                    <FileUpload
                        fileName={fileName}
                        onChange={(e) => {
                            handleOnChangeFileFactura(e);
                            if (e.target.files && e.target.files[0]) {
                                change('file', e.target.files[0]);
                            }
                        }}
                        onClear={() => {
                            handleOnChangeFileFactura({ target: { files: [] } });
                            change('file', null);
                        }}
                        label="Archivo de Factura"
                        inputId="file-upload-cargar-factura"
                    />
                )}
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Grid
                            container
                            style={{
                                borderTop: '1px solid #dcddde',
                                paddingTop: '24px',
                                paddingBottom: '24px',
                                marginTop: '20px',
                                paddingLeft: '24px',
                                paddingRight: '24px',
                                marginLeft: '-24px',
                                marginRight: '-24px',
                                width: 'calc(100% + 48px)'
                            }}
                            justify="flex-end"
                            alignItems="center"
                            spacing={2}>
                            <Grid item>
                                <Button
                                    variant="outlined"
                                    color="default"
                                    style={{ width: '190px', height: '40px' }}
                                    onClick={handleClose}>
                                    Cancelar
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disabled={props.invalid || props.submitting}
                                    style={{ width: '190px', height: '40px', marginLeft: '8px' }}>
                                    Cargar Factura
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </Container>
    );
};

FormCargarFactura = reduxForm({
    form: 'cargarFactura'
})(FormCargarFactura);

export default connect((state, props) => ({
    initialValues: {
        file: '',
        fecha: null,
        numero: '',
        monto: '0',
        iva: '0',
        descripcion: 'Compra de ',
        comentario: ''
    },
    enableReinitialize: true,
    validate
}))(FormCargarFactura);
